import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { useStyles } from "./styles";

interface Props {
  inviteeEmail: string;
}

export const EventSpeakerNudge = ({ inviteeEmail }: Props) => {
  const { t } = useI18n(["eventLanding"]);
  const styles = useStyles();

  return (
    <div className={styles.messageContainer}>
      <Typography variant="body1" className={styles.messageTitle}>
        {t("eventLanding:event.speaker")}
      </Typography>
      <Typography variant="body1" className={styles.messageContent}>
        {t("eventLanding:event.speaker.access.email", {
          email: inviteeEmail,
        })}
      </Typography>
    </div>
  );
};
